const Step2Data = {
  subtitle: {
    pl: "Uzupełnij dane niezbędne do wyliczenia Twojego ROI:",
    en: "Complete the data necessary to calculate your ROI:",
  },
  moveon: {
    pl: "Wypełnij wszystkie kategorie aby przejść dalej",
    en: "Fill in all categories to move on",
  },
};
export default Step2Data;
